import { Column } from '@testsigma/atoms';
import classNames from 'classnames';

interface UsageDetailsListItemProps {
  columnDetails;
}

export const UsageDetailsListItem: React.FC<UsageDetailsListItemProps> = ({
  columnDetails,
}) => {
  return (
    <div className='h-16 flex items-center basis-full cursor-pointer hover:bg-secondary-50 gap-x-3 px-4 w-full'>
      {columnDetails.map((colData, ind) => {
        return colData.map((data, idx) => {
          return (
            <Column
              key={`${ind}_${idx}`}
              width={data.width}
              className={classNames(
                'text-small leading-5 text-unique-600 flex flex-wrap',
                data.className,
              )}>
              {data.childDom}
            </Column>
          );
        });
      })}
    </div>
  );
};
